'use strict';
const angular = require('angular');

export class MemberSearchComponent {
  /*@ngInject*/
  constructor($state) {
    this.$state = $state;
  }

  go($event) {
    if (!$event || $event.keyCode == 13)
      this.$state.go('master-user-directory',{searchterm: this.searchTerm});
  }
}

export default angular.module('conduuApp.memberSearch', [])
  .component('memberSearch', {
    template: `

<div class="panel panel-default col-md-6  col-md-offset-3">
  <div class="panel-body">
     <div class="input-group">
      <input style="font-size: large; height: 43px" type="text" class="form-control" placeholder="Search for member by name or profession &hellip;" ng-keyup="ctrl.go($event)" ng-model="ctrl.searchTerm">
      <span class="input-group-btn">
        <button style="font-size: large; height: 43px" class="btn btn-default" ng-click="ctrl.go()" ng-disabled="!ctrl.searchTerm" type="button">Go!</button>
      </span>
    </div>
  </div>
</div>
`,
    bindings: {},
    controller: MemberSearchComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/member-search/member-search.component.js